import { DebitBalanceService } from './../../services/toro-lumen/debit-balance.service';
import { ActionEventsEnum } from '@toro/common/shared/enum/tracking/action-events.enum';
import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TooltipDirectiveModule } from '@toro/common/shared/directives/tooltip/tooltip.module';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { DialogPanelComponentContent } from '@toro/common/shared/models/dialogs/DialogPanelComponentContent';
import { ConsolidatedPosition } from '@toro/common/shared/models/pos-risk/consolidated-position';
import { FinanceActions } from '@toro/common/shared/state-management/finance/finance.action';
import { Subscription } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { LeverageLevel } from '../../../enum/leverageLevel.enum';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';

@Component({
  selector: "app-guarantee-asid   e-panel",
  templateUrl: "./guarantee-aside-panel.component.html",
  styleUrls: ["./guarantee-aside-panel.component.scss"],
  viewProviders: [TooltipDirectiveModule],
  encapsulation: ViewEncapsulation.None,
})
export class GuaranteeAsidePanelComponent extends DialogPanelComponentContent {
  public leverageLevel: LeverageLevel;
  public accountBalance: number;
  public totalNetEquity: number;
  public totalOperationGuarantee: number;
  public totalRequiredGuaranteeFactor: number;
  private disposableSubscriptions: Subscription[] = [];
  public debitBalance: number;
  public doesNotHasEngoughBalance: boolean;

  public constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    @Inject(DOCUMENT) private document: Document,
    public elementRef: ElementRef,
    private dialogReference: MatDialogRef<GuaranteeAsidePanelComponent>,
    private store: Store<AppState>,
    private router: Router,
    private debitBalanceService: DebitBalanceService
  ) {
    super(elementRef, true);
    this.document.body.classList.add("freeze");

    this.sendTracking(ActionEventsEnum.MODAL_OPENED, {
      'Product Area Origin': 'Bolsa',
      'Time Responsavel': 'Roebling',
      'Scenario': this.trackingModalScenario(),
      'Step': 'Garantias',
    });

    this.bindFinanceSubscribe();

    this.debitBalanceService.getDebitBalance().pipe(
      tap((balance) => {
        this.debitBalance = balance.data.value;
        this.doesNotHasEngoughBalance = balance.data.value > 0 && (balance.data.value > this.accountBalance);
      })
    ).subscribe();
  }

  /**
   * Recebe informações financeiras consolidadas
   */
  public bindFinanceSubscribe() {
    this.dispatchFinance();
    this.disposableSubscriptions.push(
      this.store
        .select((financeStore) => financeStore.finance.consolidatePosition)
        .pipe(filter((consolidatePosition) => !!consolidatePosition))
        .subscribe((consolidatePosition: ConsolidatedPosition) => {
          this.leverageLevel = consolidatePosition.leverageLevel;
          this.accountBalance = consolidatePosition.accountBalance;
          this.totalNetEquity = consolidatePosition.totalNetEquity;
          this.totalOperationGuarantee =
            consolidatePosition.totalOperationGuarantee;
          this.totalRequiredGuaranteeFactor =
            consolidatePosition.totalRequiredGuaranteeFactor;
      })
    );
  }

  public dispatchFinance() {
    this.store.dispatch({type: FinanceActions.getRealtimeConsolidatedPosition});
    this.store.dispatch({ type: FinanceActions.getRealtimeFinancePosition });
  }

  /**
   * Encerra componente, habilita overflow e destroi dialogReference
   */
  public closeDialog() {
    this.document.body.classList.remove("freeze");
    this.close(this.dialogReference, null);
    this.dialogReference = null;
    this.router.navigateByUrl("/meus-investimentos");
  }

  public sendTracking(event: string, breakdowns: any) {
    this.store.dispatch({
        type: TrackingActions.trackEvents,
        payload: { type: event, events: breakdowns },
    });
  }

  public sendMoreInfoTracking() {
    this.sendTracking(ActionEventsEnum.ELEMENT_CLICKED, {
      'Product Area Origin': 'Bolsa',
      'Element': 'Link saiba mais',
      'Time Responsavel': 'Roebling',
      'Step': 'Garantias',
    });
  }

  public trackingModalScenario(): string {
    if(this.debitBalance > 0) {
      return 'Garantia em uso';
    }  
    
    if (this.debitBalance > 0 && this.doesNotHasEngoughBalance) {
      return 'Saldo insuficiente';
    }

    return 'Sem uso de garantia';
  }
}
